module.exports = __webpack_public_path__ + "img/1.46104df6.jpg";